<script setup>
  const { event } = defineProps({ event: Object });
</script>

<!----------------------------------------------------------------------------->

<template>
  <WatchCard :event="event">
    <h2>
      <FightTitleCombo>
        <template v-slot:whiteCorner>{{ event.white_corner?.last_name ?? 'TBD' }}</template>
        <template v-slot:blackCorner>{{ event.black_corner?.last_name ?? 'TBD' }}</template>
      </FightTitleCombo>
    </h2>
  </WatchCard>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped></style>
